import React, { useState, useEffect } from 'react'
import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import OnboardingBanner from '../../../pages/home/sections/onboarding-banner'
import { useApplicationContext } from '../../../context/ApplicationContext'
import axios from '../../../utils/axios-util'
import {
  CaptionText,
  Col,
  Container,
  HeadingText,
  Row,
} from '@paypalcorp/pp-react'
import AppSwitcher from '../../../pages/applications/sections/app-switcher'
import DateRangeSelect from '../../../pages/applications/sections/date-range-select'
import SummaryBadge from '../../../pages/home/sections/summary-badge'
import { loadUserPreferences } from '../../../helper/user-helper'
import Spinner from '../../common/spinner'

function PreArticle() {
  const {
    isAppsDataListLoading,
    csrf,
    setCurrentBannerStep,
    setUserPreferences,
    enviroment,
    errorSummaryCount,
    failedTransactions,
    user,
    banner,
    isBannerHidden,
  } = useApplicationContext()

  const [isOnboardingBannerClosed, setIsOnboardingBannerClosed] = useState(true)
  const [isTransactionBadgeClosed, setIsTransactionBadgeClosed] = useState(true)
  const [isErrorSummaryBadgeClosed, setIsErrorSummaryBadgeClosed] = useState(
    true,
  )

  const [bannerPage, setBannerPage] = useState(0)
  const [productIntegration, setProductIntegration] = useState('')
  const [isBannerInfoLoaded, setIsBannerInfoLoaded] = useState(false)
  const [isUserPreferenceLoaded, setIsUserPreferenceLoaded] = useState(false)
  const [isSavingUserPreferences, setIsSavingUserPreferences] = useState(false)

  const BANNER_PREFERENCE_NAME = 'ONBOARDING_BANNER'
  const BANNER_PREFERENCE_VALUE = 'CLOSED'

  const getBannerProgress = () => {
    axios({
      method: 'get',
      url: '/dashboard/bannerProgress',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-csrf-token': csrf,
      },
      responseType: 'json',
      contentType: 'application/json',
    }).then(({ data }) => {
      setBannerPage(data?.bannerProgress || 0)
      setProductIntegration(data?.productIntegration || 'stdCheckout')
      setIsTransactionBadgeClosed(data?.closeTransactionBanner)
      setIsErrorSummaryBadgeClosed(data?.closeErrorSummaryBanner)
      setIsBannerInfoLoaded(true)
      const sessionObject = {
        bannerPage: data?.bannerProgress || 0,
        closeOnboardingBanner: data?.closeOnboardingBanner || false,
      }
      setCurrentBannerStep(sessionObject)
    })
  }

  const getUserPreferences = async () => {
    const preferences = await loadUserPreferences()
    setUserPreferences(preferences)

    const userBannerPreference = preferences.find(
      (userPreference) => userPreference.devup_name === BANNER_PREFERENCE_NAME,
    )

    if (userBannerPreference) {
      setIsOnboardingBannerClosed(
        userBannerPreference.devup_value === BANNER_PREFERENCE_VALUE,
      )
    } else {
      setIsOnboardingBannerClosed(false)
    }

    setIsUserPreferenceLoaded(true)
  }

  useEffect(() => {
    getBannerProgress()
    getUserPreferences()
  }, [])

  return (
    <div
      className={
        banner.isActive === 'on' && !isBannerHidden
          ? 'dev_dash__page--pre-article__wrapper_banner'
          : 'dev_dash__page--pre-article__wrapper'
      }
    >
      {!user.unauthorized === true && (
        <div className="dev_dash__page--pre-article__content--container">
          {isSavingUserPreferences && <Spinner fullScreen={true} size="xl" />}
          <Container
            xxl={true}
            data-testid="dashboard-home-page__prearticle"
            className="dashboard_home__prearticle"
          >
            <div>
              <Row>
                <Col md={7}>
                  <HeadingText className="caption-article">
                    <Message id="onboarding-banner.prearticle.title" />
                  </HeadingText>
                  <CaptionText className="caption-prearticle">
                    <Message id="onboarding-banner.prearticle.subtitle" />
                  </CaptionText>
                </Col>
                <Col md={3}>
                  <AppSwitcher />
                </Col>
                <Col md={2}>
                  <DateRangeSelect />
                </Col>
              </Row>
            </div>

            <Row>
              <Col>
                <div className="summary_badge-container">
                  {/* show Summaries based on (1) enviroment, (2) Onboarding banner is closed, and (3) Badge not aleady dismissed */}
                  {isOnboardingBannerClosed && !isErrorSummaryBadgeClosed && (
                    <SummaryBadge
                      type="error-log"
                      closeBadge={setIsErrorSummaryBadgeClosed}
                      linkFullPage={`errors/${enviroment}`}
                      count={errorSummaryCount}
                    />
                  )}
                  {enviroment === 'live' &&
                    isOnboardingBannerClosed &&
                    !isTransactionBadgeClosed && (
                      <SummaryBadge
                        type="recent-transactions"
                        closeBadge={setIsTransactionBadgeClosed}
                        linkFullPage=""
                        count={failedTransactions.length}
                      />
                    )}
                </div>
              </Col>
            </Row>

            <br />
            <div className="section-onboarding_banner">
              {!isOnboardingBannerClosed &&
                !isAppsDataListLoading &&
                isBannerInfoLoaded &&
                isUserPreferenceLoaded && (
                  <OnboardingBanner
                    closeBanner={setIsOnboardingBannerClosed}
                    bannerPage={bannerPage}
                    setBannerPage={setBannerPage}
                    productIntegration={productIntegration}
                    setProductIntegration={setProductIntegration}
                    setIsSavingUserPreferences={setIsSavingUserPreferences}
                  />
                )}
            </div>
          </Container>
        </div>
      )}
    </div>
  )
}

export default injectWorldReady(PreArticle)
